"use client";
import React, { useState } from "react";
import SelectLenses from "./SelectLenses";

import { getWebpUrl } from "@/src/utils";
import stl from "./colorComfirmBtn.module.scss";
import { tranColorByName } from "@/lib/commonService";
import { FmButton, FmDrawer, FmImage } from "@/ui-component";
import { useProductDetailsContext } from "@/src/provider";
import classnames from "classnames";
import { useTranslation } from "@/src/i18n/client";
import ColorSelect, { GlassColor } from "@/src/components/ColorSelect";

interface Props {
    open: boolean;
    onClose: (open: boolean) => void;
}

const ColorComfirmDrawer: React.FC<Props> = (props) => {
    const { open, onClose } = props;
    const { t } = useTranslation(["common", "productDetail"]);
    const [productImgList, colorList, activeObj, changeColor] =
        useProductDetailsContext((state) => [
            state.productImgList,
            state.colorList,
            state.activeObj,
            state.changeColor,
        ]);

    return (
        <FmDrawer
            open={open}
            onClose={() => onClose(false)}
            anchor="bottom"
            headerChildren
        >
            {open && (
                <div className={stl["color-select-container"]}>
                    <div className={stl["color-main-img"]}>
                        <FmImage
                            image={getWebpUrl(productImgList[1])}
                            defaultImage={productImgList[1]}
                        />
                    </div>

                    <div
                        className={classnames(
                            stl["product-detail-title"],
                            stl["color-title"],
                        )}
                    >
                        <span>{t("common:Color")}: </span>
                        {`${tranColorByName({ t, color_name: activeObj.name })} (${activeObj.colorNum})`}
                    </div>
                    <ColorSelect
                        selected={activeObj.id!}
                        onChange={(val: number) => changeColor(val)}
                        className={stl["color-select"]}
                        scale={1.5}
                    >
                        {colorList.filter((item) => item.status !== 0).map((item) => (
                            <GlassColor
                                scale={1.5}
                                key={item.id}
                                {...item}
                                color_id={item.id}
                                color_name={item.name}
                            />
                        ))}
                    </ColorSelect>
                    <SelectLenses
                        style={{
                            height: "0.7rem",
                            marginZTop: "0.4rem",
                        }}
                    />
                </div>
            )}
        </FmDrawer>
    );
};

export default ColorComfirmDrawer;
